/* IMPORTANT when you're upgrading to the next version, you'll need to do a diff of OSS current to next
 * We've essentially forked this file, so we won't get changes. Checkout the diff to make sure we don't need to change anything.
 *    cd ~/repos/oss/deck
 #    git diff upstream/release-1.14.x..upstream/release-x app/scripts/app.ts
 * Also, check our webpack.config.js for changes!
*/

import 'jquery'; // ensures jQuery is loaded before Angular so Angular does not use jqlite
import { module } from 'angular';

import { CORE_MODULE, OverrideRegistry } from '@spinnaker/core';
import { DOCKER_MODULE } from '@spinnaker/docker';
import { AMAZON_MODULE } from '@spinnaker/amazon';
import { APPENGINE_MODULE } from '@spinnaker/appengine';
import { GOOGLE_MODULE } from '@spinnaker/google';
import { KUBERNETES_MODULE } from '@spinnaker/kubernetes';
import { ECS_MODULE } from '@spinnaker/ecs';
import '@spinnaker/cloudfoundry';
import { AZURE_MODULE } from '@spinnaker/azure';
import { HUAWEICLOUD_MODULE } from '@spinnaker/huaweicloud';

// NOTE:  The canary module (barometer) should probably be deprecated anyway,
//        BUT!  The load test module might be worth saving.  Unfortunately,
//        as-is, these imports break Deck miserably, so we've just fully
//        disabled them for now.
// import { LOADTEST_MODULE } from './spinnaker.modules/loadtest';

import { ARMORY_MODULE } from './spinnaker.modules';
import { SLA_V1_MODULE } from './spinnaker.modules/sla.v1/sla.module';
import { SLA_V2_MODULE } from './spinnaker.modules/sla.v2/sla.module';
import { ARMORY_HEADER_MODULE } from 'spinnaker.modules/header/ArmoryHeader';
import { ARMORY_KAYENTA_MODULE } from './spinnaker.modules/armoryKayenta/armoryKayenta.module';
import { DINGHY_EVENTS_STATE_PROVIDER } from './spinnaker.modules/dinghyEvents/dinghyEvents.state.provider';
import { ARMORY_PIPELINE_METADATA_MODULE } from './spinnaker.modules/pipeline/override/MetadataPageContent';

import { SETTINGS } from '@spinnaker/core';

import { bootstrap, element } from 'angular';

const modules = [
  CORE_MODULE,
  AMAZON_MODULE,
  GOOGLE_MODULE,
  ECS_MODULE,
  AZURE_MODULE,
  DOCKER_MODULE,
  APPENGINE_MODULE,
  KUBERNETES_MODULE,
  HUAWEICLOUD_MODULE,
  ARMORY_MODULE,
  ARMORY_HEADER_MODULE,
  ARMORY_KAYENTA_MODULE,
  DINGHY_EVENTS_STATE_PROVIDER,
  ARMORY_PIPELINE_METADATA_MODULE,
];

/*
if (SETTINGS.feature.loadtestStageEnabled) {
  modules.push(LOADTEST_MODULE);
}
*/

if (SETTINGS.feature.armoryPlatformEnabled) {
  modules.push(SLA_V2_MODULE);
} else {
  // Check legacy feature flags that are not compatible with the new platform.
  if (SETTINGS.feature.slaEnabled) {
    modules.push(SLA_V1_MODULE);
  }
}

module('netflix.spinnaker', modules);
